// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewItem-Container_cls1__qlIVh","cls2":"PaymentViewItem-Container_cls2__EoAW2 PaymentViewItem-Container_cls1__qlIVh"};